// extracted by mini-css-extract-plugin
export default {"root":"Home_root__HWJTF","headerContainer":"Home_headerContainer__JApZM","header":"Home_header__yyeRx","gray":"Home_gray__2UMjp","first":"Home_first__l65nY"};